import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";
import { motion } from "framer-motion";
import Hero from "./components/Hero";
import InfoContact from "./components/InfoContact";
import Gallery from "./components/Gallery";
import Registration from "./components/Registration";
import Survey from "./pages/Survey";
import Footer from "./components/Footer";
import NotFound from "./pages/NotFound";
import CookieBanner from "./components/CookieBanner";

const App = () => {
  return (
    // <ParallaxProvider>
    <Router>
      <motion.div className="bg-cream text-navy font-baloo antialiased min-h-screen w-screen overflow-x-hidden relative">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Hero />
                <InfoContact />
                <Gallery />
                <Registration />
              </>
            }
          />
          <Route path="/prieskum" element={<Survey />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <CookieBanner />
        {/* Footer */}
        <Footer />
        {/* Hravé pozadie */}
        <motion.div
          className="absolute top-20 left-20 w-24 h-24 bg-primary/20 rounded-full"
          animate={{ y: [0, -60, 0], scale: [1, 1.3, 1] }}
          transition={{ duration: 5, repeat: Infinity }}
        />
        <motion.div
          className="absolute bottom-32 right-32 w-16 h-16 bg-secondary/20 rounded-full"
          animate={{ y: [0, 40, 0], scale: [1, 1.2, 1] }}
          transition={{ duration: 4, repeat: Infinity }}
        />
      </motion.div>
    </Router>
    // </ParallaxProvider>
  );
};

export default App;
